export function Card({ children, className = "" }) {
  return (
    <div
      className={className}
      style={{
        border: '1px solid #ccc',
        borderRadius: '8px',
        padding: '1rem',
        boxShadow: '2px 2px 5px rgba(0,0,0,0.1)'
      }}
    >
      {children}
    </div>
  );
}

// Esporta anche CardContent
export function CardContent({ children }) {
  return (
    <div style={{ padding: '0.5rem 0' }}>
      {children}
    </div>
  );
}
